import React, { createContext, useContext, useMemo, ReactNode } from 'react';

interface MessageTrackingContextType {
  messageId?: string;
  messageType?: string;
  messageTitle?: string;
}

const MessageTrackingContext = createContext<MessageTrackingContextType | undefined>(undefined);

export const useMessageTrackingContext = () => useContext(MessageTrackingContext);

interface MessageTrackingProviderProps {
  messageId?: string;
  messageType?: string;
  messageTitle?: string;
  children: ReactNode;
}

export const MessageTrackingProvider = ({
  messageId,
  messageType,
  messageTitle,
  children,
}: MessageTrackingProviderProps) => {
  const value = useMemo(() => ({ messageId, messageType, messageTitle }), [messageId, messageType, messageTitle]);

  return <MessageTrackingContext.Provider value={value}>{children}</MessageTrackingContext.Provider>;
};
